import React from 'react'
import { t } from 'ttag'

import { Form } from 'components/shared/Form/Form'

import { FILE_FIELD } from './model'

export const ImportCandidatesForm = ({ control, formState }) => (
  <Form>
    <Form.Field
      accept=".xlsx"
      error={formState.errors[FILE_FIELD]?.message}
      field="file"
      label={t`Files`}
      name={FILE_FIELD}
      type="file"
      multiple
      {...{ control }}
    />
  </Form>
)
